module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"restrictions-register:title":"Реестр закрытых участков дорог","restrictions-register:tooltip-map":"Показать на карте","restrictions-register:tooltip-edit":"Подробная информация и редактирование"},"en":{"restrictions-register:title":"Register of closed road sections","restrictions-register:tooltip-map":"Show on the map","restrictions-register:tooltip-edit":"Details and editing"}}')
  delete Component.options._Ctor
}
